/**
 * Store: Next day shipping
 * -----------------------------------------------------------------------------
 * Handles market data.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    markets: [],
    settings: {
      countdown: 2,
      enable: true,
      fallbackUrl: '',
      seconds: false,
    },
  }),

  mutations: {

    /**
     * Set markets.
     * @param {Array} markets - Next day shipping markets.
     */
    SET_MARKETS(state, markets) {
      state.markets = markets
    },

    /**
     * Set settings.
     * @param {Object} settings - Section settings.
     */
    SET_SETTINGS(state, settings) {
      state.settings = settings
    },
  },

  actions: {

    /**
     * Commit markets.
     * @param {Array} markets - Next day shipping markets.
     */
    setMarkets({ commit }, markets) {
      commit('SET_MARKETS', markets)
    },

    /**
     * Commit settings.
     * @param {Object} settings - Section settings.
     */
    setSettings({ commit }, settings) {
      commit('SET_SETTINGS', settings)
    },
  },
}
